import { Autocomplete, GoogleMap } from '@react-google-maps/api';
import PlaceIcon from '@mui/icons-material/Place';
import { useRef, useEffect } from 'react';
import { FieldAppearance, Input } from '@sm-dashboard/ui-components';

export const ISRAEL_PLACES_RESTRICTIONS: google.maps.places.ComponentRestrictions = { country: 'il' };

export const GoogleMapAutocomplete = ({
  appearance = 'default',
  placeholder,
  onLoad,
  onPlaceChanged,
  label,
  disabled = false,
  helperText,
  restrictions = ISRAEL_PLACES_RESTRICTIONS,
  worldwide = false
}: {
  appearance?: FieldAppearance;
  placeholder: string;
  onLoad: (autocompleteLoad: google.maps.places.Autocomplete) => void;
  onPlaceChanged?: () => void;
  label?: string;
  disabled?: boolean;
  helperText?: string;
  restrictions?: google.maps.places.ComponentRestrictions;
  worldwide?: boolean;
}) => {
  const autoCompleteRef = useRef(null);

  useEffect(() => {
    if (autoCompleteRef?.current) {
      const inputElement = (autoCompleteRef.current as HTMLElement).querySelector('div > div:nth-child(1)');
      if (inputElement && inputElement instanceof HTMLElement) {
        inputElement.style.backgroundColor = 'transparent';
      }
    }
  }, [autoCompleteRef]);

  return (
    <div ref={autoCompleteRef} style={{ width: '100%' }}>
      <style>
        {`
          .pac-container {
            z-index: 1301 !important;
          }
        `}
      </style>
      <GoogleMap mapContainerClassName="map-container">
        <Autocomplete
          key={worldwide ? 'places-world' : 'places-il'}
          onLoad={onLoad}
          onPlaceChanged={onPlaceChanged}
          restrictions={worldwide ? undefined : restrictions}
        >
          <Input
            appearance={appearance}
            label={label}
            helperText={helperText}
            placeholder={placeholder}
            disabled={disabled}
            startIcon={<PlaceIcon />}
          />
        </Autocomplete>
      </GoogleMap>
    </div>
  );
};

export default GoogleMapAutocomplete;
